function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import CustomPopover from "@com/components/custom-popover/index.vue";
import { computed, defineComponent } from "vue";
import { filterSchemaConfig } from "@pt/views/pt-entry/components/filter-bar/filter-model";
import { format } from "date-fns";
import i18n from "@/lang";
export default defineComponent({
    components: {
        CustomPopover: CustomPopover
    },
    props: {
        model: Object
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var label = i18n.t("resourceManager.filter.date");
        var popoverSchema = [
            [
                {
                    label: i18n.t("resourceManager.filter.createdate")
                },
                filterSchemaConfig.created_time, 
            ],
            [
                {
                    label: i18n.t("resourceManager.filter.updatedate")
                },
                filterSchemaConfig.updated_time, 
            ], 
        ];
        var durationPopoverConfig = {
            width: 310
        };
        var durationSelectedValue = computed(function() {
            var createdTime = props.model.created_time.map(function(t) {
                return format(new Date(t), "YYYY/MM/DD");
            });
            var updatedTime = props.model.updated_time.map(function(t) {
                return format(new Date(t), "YYYY/MM/DD");
            });
            var createdValue = "";
            var updatedValue = "";
            var value = [];
            if (createdTime.length) {
                createdValue = "".concat(i18n.t("resourceManager.filter.createdate"), ":").concat(createdTime[0], "-").concat(createdTime[1]);
                value.push({
                    label: createdValue,
                    value: "createdTime"
                });
            }
            if (updatedTime.length) {
                updatedValue = "".concat(i18n.t("resourceManager.filter.updatedate"), ":").concat(updatedTime[0], "-").concat(updatedTime[1]);
                value.push({
                    label: updatedValue,
                    value: "updatedTime"
                });
            }
            return value;
        });
        var handleChange = function(value) {
            emit("change", value);
        };
        var clearcreatedTimeValue = [
            {
                prop: "created_time",
                value: []
            }, 
        ];
        var clearupdatedTimeValue = [
            {
                prop: "updated_time",
                value: []
            }, 
        ];
        var deleteTag = function(tag) {
            if (tag === "createdTime") {
                emit("change", clearcreatedTimeValue);
            } else if (tag === "updatedTime") {
                emit("change", clearupdatedTimeValue);
            }
        };
        var handleClearClick = function(event) {
            emit("change", _toConsumableArray(clearcreatedTimeValue).concat(_toConsumableArray(clearupdatedTimeValue)));
        };
        return {
            label: label,
            durationPopoverConfig: durationPopoverConfig,
            popoverSchema: popoverSchema,
            durationSelectedValue: durationSelectedValue,
            handleChange: handleChange,
            deleteTag: deleteTag,
            handleClearClick: handleClearClick
        };
    }
});
